// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Asd9L","spin":"Spinner_spin__OnVtK"};